import axios from '@api/axios';

const axiosInstance = axios.create({
    baseURL: `/api/`
});

const counties = function(paginatorOptions = null) {
    return axiosInstance.get('counties', {
        params: paginatorOptions
    });
};

const checkPostalCode = function(postalCode) {
    return axiosInstance.get(`postal_codes/${postalCode}`);
};

const defaultInput = function() {
    return {
        line1: '',
        line2: '',
        postalCode: '',
        city: '',
        county: null,
        latitude: null,
        longitude: null
    };
};

export default { axios: axiosInstance, counties, checkPostalCode, defaultInput };
